import Bao from "../../services/bao-service";
import TabPage from "../../factories/tab-page";
import SubscriptionViewModel from "../../factories/subscription-view-model";
import * as ko from "knockout";

/**
* UADM User->Roles and Roles->User Export Model
*/
class UADMExportReport extends SubscriptionViewModel {

    Parent: any;
    TabPage: TabPage;

    Selection = ko.observableArray([]);
    TableControlKey: KnockoutObservable<string> = ko.observable("UadmMapping");
    AvailableColumns: KnockoutObservableArray<any> = ko.observableArray();

    constructor(parent: any) {
        super(parent);
        this.TabPage = parent.TabPage;
        this.Parent = parent;
    }

    /**
     * The first function called after an instance of this tab has been created
     */
    init = () => {
        this.TabPage.IsLoading(true);
        this.TabPage.IconLeft("fal fa-dot-circle");
        this.AvailableColumns(this.GetAllDataGridColumns());
    }

    GetUserRoleMappings = async (headerFilters, skip, take, sortingParam) => {
        let url = "UadmExport/GetUadmMappings";
        if (headerFilters?.length > 0) {
            url += "?$filter=" + headerFilters;
            url = encodeURI(url);
        }
        const result = await Bao.post(url, JSON.stringify({
            skip: skip,
            take: take,
            sorting: sortingParam
        }));

        if (result != null) {
            return {
                data: result.Models,
                totalCount: result.TotalRows
            };
        }
        else {
            return null;
        }
    }

    GetAllDataGridColumns() {
        let labels = Bao.Session.GetMessage([
            "ColUsername",
            "ColLastName",
            "ColFirstName",
            "msgGridColRoleName",
            "msgEmail",
            "msgGridColLocked",
            "msgGridColDescription"
        ]);

        return [
            {
                HeaderText: labels["ColUsername"],
                PropertyName: "Username",
                Clickable: true,
                Filterable: true
            },
            {
                HeaderText: labels["ColLastName"],
                PropertyName: "Lastname",
                Filterable: true
            },
            {
                HeaderText: labels["ColFirstName"],
                PropertyName: "Firstname",
                Filterable: true
            },
            {
                HeaderText: labels["msgGridColRoleName"],
                PropertyName: "RoleName",
                Filterable: true
            },
            {
                HeaderText: labels["msgEmail"],
                PropertyName: "Email",
                Filterable: true
            },
            {
                HeaderText: labels["msgGridColLocked"],
                PropertyName: "UserDisabledHtml",
                Filterable: false,
                Clickable: false,
                DisplayAsHtml: false
            },
            {
                HeaderText: labels["msgGridColDescription"],
                PropertyName: "Description",
                Filterable: true
            }
        ];
    }

    /**
    * Get all of the rows for the DataGrid depending on the supplied parameters
    * @param headerFilters - Filters used in the request URL (see {@link https://learn.microsoft.com/en-us/odata/concepts/queryoptions-overview})
    * @param skip - The number of rows to skip
    * @param take - The number of rows to take
    * @param sortingParam - The columns to sort by and the direction to sort
    * @param groupingParam - The columns to group by
    */
    loadReportTableControlData = async (headerFilters, skip, take, sortingParam, groupingParam) => {
        this.TabPage.IsLoading(true);
        let result = await this.GetUserRoleMappings(headerFilters,skip,take,sortingParam);
        this.TabPage.IsLoading(false);
        
        return result;
    }

    /**
     * Gets the EdmModel for the DataGrid (Each DataType of the InfoModel-Properties)
    */
    loadReportModelMetadata = () => {
        return Bao.post("UadmExport/GetModelMetadata", null).then(result => {
            return result?.EdmModel;
        });
    }

    /**
    * calls generic DownloadReport function to get role-to-user report
    */
    DownloadRoleReport = () => {
        this.DownloadReport("GenerateRolesUserReport");
    };

    /**
    * calls generic DownloadReport function to get user-to-role report
    */
    DownloadUserReport = () => {
        this.DownloadReport("GenerateUserRolesReport");
    };

    /**
    * calls ReportCenterController to generate UADM reports
    */
    DownloadReport = (reportType: string) => {
        this.TabPage.IsLoading(true);
        return Bao.post("ReportCenter/" + reportType).then(result => {
            window.open(Bao.Content("BaoDocument/Download/" + result.Report), "_blank");
        }).always(_ => {
            this.TabPage.IsLoading(false);
        });
    };
}

export default UADMExportReport;